<template>
	<div>
		<!-- <TilteParallax
			image="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"
		> -->
		<TilteParallax
			image="https://apps.pinturasacuario.mx/assets/store/images/customer/article.jpg"
		>
			<template v-slot:title>
				Carrito de compra
			</template>

			<template v-slot:subtitle>
				{{ articles.length }} artículos en su carrito.
			</template>
		</TilteParallax>

		<v-container fluid class="pt-0">
			<v-row justify="center">
				<v-col
					cols="12"
					md="10"
					:class="{ 'pa-0': $vuetify.breakpoint.smAndDown }"
				>
					<v-card
						outlined
						:class="[
							$vuetify.breakpoint.smAndDown
								? 'pa-0 pt-0'
								: 'pa-10',
							'pb-5',
						]"
					>
						<v-card-text>
							<template v-if="articles.length === 0">
								<v-row>
									<v-col
										cols="12"
										class="d-flex justify-center align-center flex-column text-center"
										style="height: 50vh;"
									>
										<h1 class="mb-3">
											Su carrito está vacío
										</h1>

										<h3 class="font-weight-light">
											Conozca la gran variedad de
											productos que Pinturas Acuario tiene
											para usted.
										</h3>

										<router-link
											:to="{ name: 'StoreIndex' }"
										>
											<v-btn
												color="primary"
												class="mt-8"
												large
											>
												ir a la tienda
											</v-btn>
										</router-link>
									</v-col>
								</v-row>
							</template>

							<template v-else>
								<v-row
									v-for="(article, key) in articles"
									class="article"
									justify="center"
								>
									<v-col
										md="2"
										cols="12"
										@click="
											$router.push({
												name: 'PrductShow',
												params: {
													id: article.product_id,
												},
											})
										"
										:class="[
											'd-flex',
											'align-center',
											$vuetify.breakpoint.smAndDown
												? 'justify-center'
												: 'justify-space-between',
										]"
										style="cursor: pointer;"
									>
										<strong class="ml-4 mr-2 black--text">
											{{ key + 1 }}
										</strong>

										<div
											class="d-flex justify-center main-image-container"
										>
											<img
												v-if="mainImage(article)"
												:src="mainImage(article)"
												class="main-image"
												alt=""
											/>

											<div
												v-else
												class="no-image no-image-small"
											></div>
										</div>
									</v-col>

									<v-col
										cols="12"
										md="6"
										:class="[
											'd-flex',
											'flex-column',
											'justify-center',
											'align-start',
										]"
									>
										<div
											:class="[
												'd-flex',
												$vuetify.breakpoint.smAndDown
													? 'align-center mb-2'
													: 'align-start',
											]"
										>
											<h3>
												<router-link
													:to="{
														name: 'PrductShow',
														params: {
															id:
																article.product_id,
														},
													}"
												>
													{{
														`${article.description} (${article.code})`
													}}
												</router-link>
											</h3>
										</div>

										<div class="d-flex flex-column">
											<div class="d-flex">
												<div class="mr-2">
													<strong>
														Precio unitario:
													</strong>

													{{
														priceFormat(
															price(article)
														)
													}}

													<v-chip
														x-small
														class="ml-1"
														color="success"
														v-if="
															hasDiscount(article)
														"
													>
														{{
															`-${article.discount}% OFF`
														}}
													</v-chip>
												</div>

												<!-- ArticleColor Component -->
												<ArticleColor
													:article="article"
												></ArticleColor>
											</div>
											<span
												v-if="hasDiscount(article)"
												style="text-decoration: line-through;"
											>
												{{ priceFormat(article.price) }}
											</span>
										</div>

										<div class="mt-1">
											<v-btn
												text
												color="primary"
												small
												@click="remove(article, key)"
											>
												Quitar
											</v-btn>
										</div>
									</v-col>

									<v-col
										cols="12"
										md="2"
										class="d-flex align-center justify-center"
									>
										<AmountIputGroup
											@change="update"
											:article="article"
											:amount="article.amount"
										></AmountIputGroup>
									</v-col>

									<v-col
										cols="6"
										md="2"
										:class="[
											$vuetify.breakpoint.smAndDown
												? 'justify-center'
												: 'justify-end',
											'd-flex',
											'align-center',
										]"
									>
										<h3 class="black--text">
											{{
												priceFormat(
													price(article) *
														article.amount
												)
											}}
										</h3>
									</v-col>
								</v-row>

								<v-row>
									<v-col cols="12" md="6" class="d-flex">
										<div
											class="d-flex flex-column align-start font-weight-bold black--text"
											style="width: 20%;"
										>
											<span>Peso total:</span>
										</div>
										<div
											class="d-flex flex-column align-start"
											style="width: 80%;"
										>
											<span>
												{{ `${getWeight} Kg` }}
											</span>
										</div>
									</v-col>

									<v-col cols="12" md="6" class="d-flex">
										<div
											class="d-flex flex-column align-end font-weight-bold black--text"
											style="width: 60%;"
										>
											<span>Subtotal:</span>
											<span>
												{{
													`Descuento de socio(${getMemberDiscount}%):`
												}}
											</span>
											<span>IVA:</span>
											<span>Total:</span>
										</div>
										<div
											class="d-flex flex-column align-end black--text"
											style="width: 40%;"
										>
											<span>
												{{
													`${priceFormat(
														getSubTotal
													)}`
												}}
											</span>

											<span>
												{{
													getMemberDiscount > 0
														? `-${priceFormat(
																getDiscount
														  )}`
														: `${priceFormat(
																getDiscount
														  )}`
												}}
											</span>

											<span>
												{{ `${priceFormat(getIva)}` }}
											</span>
											<span class="font-weight-bold">
												{{
													`${priceFormat(
														getTotal
													)} MXN`
												}}
											</span>
										</div>
									</v-col>
								</v-row>
							</template>
						</v-card-text>

						<v-card-actions
							v-if="articles.length > 0"
							:class="[
								'd-flex',
								$vuetify.breakpoint.smAndDown
									? 'flex-column-reverse'
									: 'justify-space-between',
							]"
						>
							<v-btn
								color="primary"
								text
								class="mt-2"
								@click="clear()"
								large
								:block="$vuetify.breakpoint.smAndDown"
							>
								vaciar carrito
							</v-btn>

							<v-btn
								@click="send()"
								class="mt-2"
								color="primary"
								large
								:block="$vuetify.breakpoint.smAndDown"
							>
								enviar orden de compra
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>
		</v-container>

		<!-- CartBottomBar Component-->
		<CartBottomBar v-if="articles.length > 4"></CartBottomBar>

		<!-- PurchaceOrderCreate Component -->
		<PurchaceOrderCreate></PurchaceOrderCreate>
	</div>
</template>

<script>
import Article from "@/clas/Article";
import SalesOrder from "@/clas/Article";
import ArticleColor from "@/components/Article/Color";
import TilteParallax from "@/components/TilteParallax";
import CartBottomBar from "@/components/Cart/BottomBar";
import AmountIputGroup from "@/components/AmountIputGroup";
import PurchaceOrderCreate from "@/components/Cart/PurchaceOrderCreate";
import { mapGetters } from "vuex";

import { EventBus } from "@/main";

export default {
	name: "Cart",

	components: {
		ArticleColor,
		TilteParallax,
		CartBottomBar,
		AmountIputGroup,
		PurchaceOrderCreate,
	},

	data() {
		return {};
	},

	created() {},

	mounted() {},

	methods: {
		send() {
			EventBus.$emit("PurchaceOrderCreate");
		},

		update(article, amount) {
			this.$store.dispatch("cart/cartArticleUpdate", {
				...article,
				amount: amount,
			});
		},

		remove(article) {
			if (
				confirm(
					`¿Quiere remover este artículo?\n${article.description} (${article.code})`
				)
			) {
				this.$store.commit("cart/REMOVE_ARTICLE", article);
			}
		},

		clear() {
			if (confirm("¿Quíeres vaciar tu carrito?")) {
				this.$store.commit("cart/CLEAR");
			}
		},

		price(article) {
			let a = new Article(article);

			return a.price();
		},

		hasDiscount(article) {
			let a = new Article(article);

			return a.hasDiscount();
		},

		priceFormat(val) {
			let a = new Article();

			return a.priceFormat(val);
		},

		mainImage(article) {
			let a = new Article(article);

			return a.mainImage();
		},
	},

	computed: {
		...mapGetters({
			getIva: "cart/getIva",
			getTotal: "cart/getTotal",
			getAmount: "cart/getAmount",
			getWeight: "cart/getWeight",
			getArticles: "cart/getArticles",
			getSubTotal: "cart/getSubTotal",
			getDiscount: "cart/getDiscount",
			getMemberDiscount: "getMemberDiscount",
		}),

		articles() {
			return this.getArticles;
		},
	},
};
</script>

<style lang="css" scoped>
.article {
	border-bottom: 1px solid #ddd;
	transition: all 0.2s;
	min-height: 100px;
}

.article:hover {
	background-color: rgba(0, 0, 0, 0.03);
}

.main-image-container {
	height: 80px;
	width: 80px;
}
</style>
